import { makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
    root: ({ backgroundSize, backgroundPosition, borderRadius, sizes: [width, height], src, mt, mb }) => ({
        flexShrink: 0,
        width: width,
        height: height,
        overflow: "hidden",
        backgroundImage: `url(${src})`,
        backgroundSize: backgroundSize,
        backgroundRepeat: "no-repeat",
        backgroundPosition: backgroundPosition,
        borderRadius: borderRadius,
        margin: "auto",
        marginTop: theme.spacing(mt),
        marginBottom: theme.spacing(mb)
    })
}));
export const BackgroundImage = ({ backgroundSize = "cover", backgroundPosition = "center", borderRadius = 0, sizes, src, mt = 0, mb = 0 }) => {
    const classes = useStyles({
        backgroundSize,
        backgroundPosition,
        borderRadius,
        sizes,
        src,
        mt,
        mb
    });
    return React.createElement("div", { className: classes.root });
};
//# sourceMappingURL=BackgroundImage.js.map